import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { landingPageService, type PricingSection } from "../services/landingPageService";

interface LandingPricingState {
  data: PricingSection | null;
  loading: boolean;
  error: string | null;
}

const initialState: LandingPricingState = {
  data: null,
  loading: false,
  error: null,
};

export const fetchLandingPricing = createAsyncThunk(
  "landingPricing/fetch",
  async (_, { rejectWithValue }) => {
    try {
      return await landingPageService.getPricing();
    } catch (err: any) {
      return rejectWithValue(
        err?.response?.data?.message || "Failed to fetch pricing section"
      );
    }
  }
);

const landingPricingSlice = createSlice({
  name: "landingPricing",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLandingPricing.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLandingPricing.fulfilled, (state, action: PayloadAction<PricingSection>) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchLandingPricing.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default landingPricingSlice.reducer;